import { Injectable } from "@angular/core";

/**
 * Orchestrates a full app refresh triggered by pull-to-refresh (vault sync + optional Gloss Credits sync).
 */
@Injectable({
  providedIn: "root",
})
export class AppPullRefreshService {
  /**
   * Runs vault full sync and Gloss Credits transaction sync.
   * Skips if a sync is already in progress.
   */
  async refresh(): Promise<void> {
    window.location.reload();
    return;
  }
}
